"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/@babel/runtime/helpers/regeneratorRuntime.js").default;
var _asyncToGenerator = require("/vercel/path0/node_modules/@babel/runtime/helpers/asyncToGenerator.js").default;
var _slicedToArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/slicedToArray.js").default;
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStakerInfo = exports.useSavingsStats = exports.useSavingsFunctions = exports.useSavingsBalance = void 0;
var core_1 = require("@usedapp/core");
var ethers_1 = require("ethers");
var react_1 = require("react");
var useRefreshOrNever_1 = __importDefault(require("../../hooks/useRefreshOrNever"));
var useGasFees_1 = require("../base/hooks/useGasFees");
var react_2 = require("../base/react");
function useSavingsBalance() {
  var refresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "never";
  var requiredChainId = arguments.length > 1 ? arguments[1] : undefined;
  var _a, _b;
  var refreshOrNever = (0, useRefreshOrNever_1.default)(refresh);
  var _ref = (0, core_1.useEthers)(),
    account = _ref.account;
  var gooddollar = (0, react_2.useGetContract)("GoodDollar", true, "savings");
  var gdStaking = (0, react_2.useGetContract)("GoodDollarStaking", true, "savings");
  var results = (0, core_1.useCalls)([{
    contract: gooddollar,
    method: "balanceOf",
    args: [account]
  }, {
    contract: gdStaking,
    method: "getSavings",
    args: [account]
  }], {
    refresh: refreshOrNever,
    chainId: requiredChainId
  });
  var _results = _slicedToArray(results, 2),
    balance = _results[0],
    sBalance = _results[1];
  var g$Balance = (0, react_2.useG$Amount)((_a = balance === null || balance === void 0 ? void 0 : balance.value) === null || _a === void 0 ? void 0 : _a[0], "G$", requiredChainId);
  var savingsBalance = (0, react_2.useG$Amount)((_b = sBalance === null || sBalance === void 0 ? void 0 : sBalance.value) === null || _b === void 0 ? void 0 : _b[0], "G$", requiredChainId);
  return {
    g$Balance: g$Balance,
    savingsBalance: savingsBalance
  };
}
exports.useSavingsBalance = useSavingsBalance;
var useSavingsFunctions = function useSavingsFunctions() {
  var gooddollar = (0, react_2.useGetContract)("GoodDollar", false, "savings");
  var gdStaking = (0, react_2.useGetContract)("GoodDollarStaking", false, "savings");
  var _ref2 = (0, useGasFees_1.useContractFunctionWithDefaultGasFees)(gooddollar, "transferAndCall", {
      transactionName: "Transfer to savings"
    }),
    transferState = _ref2.state,
    sendTransfer = _ref2.send;
  var _ref3 = (0, useGasFees_1.useContractFunctionWithDefaultGasFees)(gdStaking, "withdrawStake", {
      transactionName: "Withdraw from savings"
    }),
    withdrawState = _ref3.state,
    sendWithdraw = _ref3.send;
  var _ref4 = (0, useGasFees_1.useContractFunctionWithDefaultGasFees)(gdStaking, "withdrawRewards", {
      transactionName: "Withdraw rewards from savings"
    }),
    claimState = _ref4.state,
    sendClaim = _ref4.send;
  var transfer = (0, react_1.useCallback)(function (amount) {
    var callData = ethers_1.ethers.constants.HashZero;
    return sendTransfer(gdStaking.address, amount, callData);
  }, [sendTransfer, gdStaking]);
  var withdraw = (0, react_1.useCallback)( /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(amount, address) {
      var shares;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!address) {
              _context.next = 6;
              break;
            }
            _context.next = 3;
            return gdStaking.sharesOf(address);
          case 3:
            _context.t0 = _context.sent;
            _context.next = 9;
            break;
          case 6:
            _context.next = 8;
            return gdStaking.amountToShares(amount);
          case 8:
            _context.t0 = _context.sent;
          case 9:
            shares = _context.t0;
            return _context.abrupt("return", sendWithdraw(shares));
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref5.apply(this, arguments);
    };
  }(), [sendWithdraw]);
  var claim = (0, react_1.useCallback)(function () {
    return sendClaim();
  }, [sendClaim]);
  return {
    transfer: transfer,
    withdraw: withdraw,
    claim: claim,
    transferState: transferState,
    withdrawState: withdrawState,
    claimState: claimState
  };
};
exports.useSavingsFunctions = useSavingsFunctions;
var useSavingsStats = function useSavingsStats(requiredChainId) {
  var refresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "never";
  var _a, _b, _c, _d, _e, _f, _g;
  var refreshOrNever = (0, useRefreshOrNever_1.default)(refresh);
  var _ref6 = (0, react_2.useGetEnvChainId)(requiredChainId),
    chainId = _ref6.chainId;
  var gdStaking = (0, react_2.useGetContract)("GoodDollarStaking", true, "savings", chainId);
  var results = (0, core_1.useCalls)([{
    contract: gdStaking,
    method: "stats",
    args: []
  }, {
    contract: gdStaking,
    method: "getRewardsPerBlock",
    args: []
  }, {
    contract: gdStaking,
    method: "numberOfBlocksPerYear",
    args: []
  }], {
    refresh: refreshOrNever,
    chainId: chainId
  });
  var globalStats = {
    totalStaked: undefined,
    totalRewardsPaid: undefined,
    apy: undefined
  };
  var _ref7 = (_b = (_a = results[0]) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : [],
    _ref8 = _slicedToArray(_ref7, 3),
    totalStaked = _ref8[1],
    totalRewardsPaid = _ref8[2]; // eslint-disable-line no-unsafe-optional-chaining
  var staked = (0, react_2.useG$Amount)(totalStaked, "G$", requiredChainId);
  var rewardsPaid = (0, react_2.useG$Amount)(totalRewardsPaid, "G$", requiredChainId);
  if ((_c = results[0]) === null || _c === void 0 ? void 0 : _c.error) {
    // one fails, all fails
    var errMessages = [];
    for (var i = 0; i < results.length; i++) {
      errMessages.push((_d = results[i]) === null || _d === void 0 ? void 0 : _d.error);
    }
    return {
      stats: undefined,
      error: errMessages
    };
  }
  if (staked && rewardsPaid) {
    globalStats.totalStaked = staked;
    globalStats.totalRewardsPaid = rewardsPaid;
  }
  if (results[1] && results[2]) {
    var _ref9 = ((_e = results[1]) === null || _e === void 0 ? void 0 : _e.value) || {
        _gdInterestRatePerBlock: 0
      },
      gdIrpb = _ref9._gdInterestRatePerBlock;
    var numberOfBlocksPerYear = (_g = (_f = results[2]) === null || _f === void 0 ? void 0 : _f.value) === null || _g === void 0 ? void 0 : _g[0];
    var apy = (Math.pow(gdIrpb / 1e18, numberOfBlocksPerYear) - 1) * 100;
    globalStats.apy = apy;
  }
  return {
    stats: globalStats,
    error: undefined
  };
};
exports.useSavingsStats = useSavingsStats;
var useStakerInfo = function useStakerInfo(requiredChainId) {
  var refresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "never";
  var account = arguments.length > 2 ? arguments[2] : undefined;
  var _a, _b, _c, _d, _e, _f;
  var refreshOrNever = (0, useRefreshOrNever_1.default)(refresh);
  var _ref10 = (0, react_2.useGetEnvChainId)(requiredChainId),
    chainId = _ref10.chainId;
  var contract = (0, react_2.useGetContract)("GoodDollarStaking", true, "savings", chainId);
  var results = (0, core_1.useCalls)([{
    contract: contract,
    method: "getUserPendingReward(address)",
    args: [account]
  }, {
    contract: contract,
    method: "principle",
    args: [account]
  }], {
    refresh: refreshOrNever,
    chainId: chainId
  });
  var stakerInfo = {
    claimable: undefined,
    principle: undefined
  };
  var _ref11 = (_b = (_a = results[0]) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : [],
    _ref12 = _slicedToArray(_ref11, 2),
    goodRewardValue = _ref12[0],
    g$RewardValue = _ref12[1];
  var _ref13 = (_d = (_c = results[1]) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : [],
    _ref14 = _slicedToArray(_ref13, 1),
    principle = _ref14[0];
  var g$Reward = (0, react_2.useG$Amount)(g$RewardValue, "G$", requiredChainId);
  var goodReward = (0, react_2.useG$Amount)(goodRewardValue, "GOOD", requiredChainId);
  var deposit = (0, react_2.useG$Amount)(principle, "G$", requiredChainId);
  if ((_e = results[0]) === null || _e === void 0 ? void 0 : _e.error) {
    var errMessages = [];
    for (var i = 0; i < results.length; i++) {
      errMessages.push((_f = results[i]) === null || _f === void 0 ? void 0 : _f.error);
    }
    return {
      stats: undefined,
      error: errMessages
    };
  }
  if (goodReward && g$Reward) {
    var claimableRewards = {
      g$Reward: g$Reward,
      goodReward: goodReward
    };
    stakerInfo.claimable = claimableRewards;
  }
  if (deposit) {
    stakerInfo.principle = deposit;
  }
  return {
    stats: stakerInfo,
    error: undefined
  };
};
exports.useStakerInfo = useStakerInfo;